<template>
    <Popup :show="show" v-on:closeEvent="close">
        <div class="popup-container">
            <div class="circle"></div>
            <h2>{{$t("shop.LBL_PAYMENT_SUCCESS_TITLE")}}</h2>
            <span class="text" v-html="$t('shop.LBL_PAYMENT_SUCCESS_DESCRIPTION')"></span>
            <br/>
            <span class="text">
                {{$t("shop.LBL_PAYMENT_TRANSACTION_ID")}}: {{order_number}}<br/>
                {{$t("shop.LBL_PAYMENT_TRANSACTION_DATE")}}: {{order_date}}<br/>
                {{$t("shop.LBL_PAYMENT_TRANSACTION_TOTAL")}}: {{order_total}}
            </span>

            <div class="buttons">
                <button class="button" @click="ok">
                    <span>{{$t("strings.BTN_CONFIRM")}}</span>
                </button>
            </div>
        </div>
    </Popup>
</template>

<script>

    import Popup from '../../../../components/Popup';
    import { MONTH_NAMES } from '../../../../utils/utils';

    export default {
        name: "PaySuccessPopup",
        components: {
            Popup
        },
        props: {
            show: {
                type: Boolean,
                required: true
            },
        },
        data: function () {
            return {
                order_number: "0000",
                order_date: "00.00.0000",
                order_total: "0.00 EUR"
            }
        },
        computed: {
            dateConvert() {
                //convert '2020-01-10' --> '10 IANUARIE 2020'
                let dateArr = this.date.split('-').map((item) => {
                return parseInt(item)
                });
                return `${dateArr[2]} ${MONTH_NAMES[dateArr[1] - 1]} ${dateArr[0]}`
            }
        },
        created() {
            let linkParams = this.$route.query;
            this.order_number = linkParams.order_number;
            this.order_date = linkParams.order_date;
            this.order_total = linkParams.order_total;
        },
        methods: {
            close() {
                this.$emit('closeEvent', null);
            },
            ok() {
                this.$emit('closeEvent', null);
            }
        },
    }
</script>

<style scoped lang="scss">
    .circle {
        width: 4.8rem;
        height: 4.8rem;
        background-color: #05C46B;
        border-radius: 10rem;
        margin-bottom: 1.6rem;
    }

    .popup-container {
        width: 100%;
        align-self: auto;
        display: flex;
        flex-direction: column;
    }

    h2 {
        padding-bottom: 0.8rem;
    }

    .text {
        font-family: FuturaPT;
        font-size: 1.6rem;
        line-height: 2rem;
        letter-spacing: 0.1rem;
        color: rgba(11, 16, 34, 0.3);
    }

    .buttons {
        width: 100%;
        display: flex;
        margin-top: auto;

        .button {
        margin-left: auto;
        padding: 0.75rem 2.5rem 1rem 2.5rem;
        }
    }
</style>
